/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Uploading_FileInputs */

const en_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading file...`)
};

const fr_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement du fichier...`)
};

const de_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei wird hochgeladen...`)
};

const it_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento file in corso...`)
};

const ru_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка файла...`)
};

const es_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo archivo...`)
};

const zh_cn2_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件正在上传……`)
};

const ja_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルをアップロードしています...`)
};

const hi_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल अपलोड हो रही है...`)
};

const pt_pt2_ateliere_connect_status_uploading_file = /** @type {(inputs: Ateliere_Connect_Status_Uploading_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando arquivo...`)
};

/**
* | output |
* | --- |
* | "Uploading file..." |
*
* @param {Ateliere_Connect_Status_Uploading_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_uploading_file = /** @type {((inputs?: Ateliere_Connect_Status_Uploading_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Uploading_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_uploading_file(inputs)
	if (locale === "de") return de_ateliere_connect_status_uploading_file(inputs)
	if (locale === "it") return it_ateliere_connect_status_uploading_file(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_uploading_file(inputs)
	if (locale === "es") return es_ateliere_connect_status_uploading_file(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_uploading_file(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_uploading_file(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_uploading_file(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_uploading_file(inputs)
	return en_ateliere_connect_status_uploading_file(inputs)
});